import * as base from "./base";
import * as derived from "./derived";

/**
 * Net selectors namespace
 *
 * Usage:
 * - nets.all(state) - Get all nets
 * - nets.byUid('uid')(state) - Get net by UID
 * - nets.labels(state) - Get all net labels (memoized)
 * - nets.propertiesByUid('uid')(state) - Get net properties by UID
 */
export const nets = {
    ...base,
    ...derived,
} as const;

export type NetsSelectors = typeof nets;
